import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "Page not found · Greenroute";
  }, []);
  return (
    <main className="bg-cream min-h-screen flex flex-col" data-testid="not-found-page">
      <Navbar />
      <section className="flex-1 flex items-center justify-center px-6 py-32">
        <div className="max-w-2xl text-center">
          <div className="font-serif text-[140px] md:text-[200px] text-forest/15 leading-none select-none">
            404
          </div>
          <div className="uppercase text-xs tracking-[0.3em] text-sage mb-6 mt-[-1rem]">
            Lost in the grounds
          </div>
          <h1 className="font-serif text-4xl md:text-5xl text-forest leading-tight mb-6">
            We can't find that page.
          </h1>
          <p className="text-graphite text-base md:text-lg max-w-md mx-auto leading-relaxed">
            The link may be out of date, or the page may have moved. Let us guide you back.
          </p>
          <div className="mt-12 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              data-testid="back-home-cta"
              className="inline-flex items-center justify-center gap-2 bg-forest text-cream px-7 py-4 text-sm tracking-wider hover:bg-forest/90 transition-colors"
            >
              <Home size={16} /> Return Home
            </Link>
            <Link
              to="/#contact"
              className="inline-flex items-center justify-center gap-2 border border-forest text-forest px-7 py-4 text-sm tracking-wider hover:bg-forest hover:text-cream transition-colors"
            >
              <ArrowLeft size={16} /> Talk to us
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
